/* unplugin-vue-components disabled */import script from "./dicdialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./dicdialog.vue?vue&type=script&setup=true&lang=ts"

import "./dicdialog.vue?vue&type=style&index=0&id=63a94a9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a94a9e"]])

export default __exports__